import React from "react";
import { Typography, Grid } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { CSVReader } from "react-papaparse";

const useStyles = makeStyles((theme) => ({
  root: {
    "& > *": {
      margin: theme.spacing(1),
    },
  },
  input: {
    display: "none",
  },
  paper: {
    margin: "0px auto",
    marginTop: theme.spacing(5),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },
}));

export const UploadFile = (props) => {
  const { handleHeadersChange } = props;
  const classes = useStyles();

  const handleOnDrop = (data) => {
    let receiptHeaders = data[11].data || [];
    handleHeadersChange(receiptHeaders);
  };

  return (
    <div className={classes.paper}>
      <Grid container spacing={2} justifyContent="center">
        <Grid item xs={12} sm={12}>
          <Typography component="h4" style={{ textAlign: "center" }}>
            Upload a CSV providing receipt information.
          </Typography>
        </Grid>
        <Grid item xs={6} sm={6}>
          <CSVReader onDrop={handleOnDrop} noDrop></CSVReader>
        </Grid>
      </Grid>
    </div>
  );
};

export default UploadFile;
